/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Event_Warning_Lines_TitleInputs */



/**
* | output |
* | --- |
* | "Line count warning: line count ({count}) is above max value" |
*
* @param {Event_Warning_Lines_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_lines_title = /** @type {((inputs: Event_Warning_Lines_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Lines_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Alerte lignes : le nombre de lignes (${i?.count}) dépasse la valeur maximale`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Warnung zur Zeilenanzahl: Die Zeilenanzahl (${i?.count}) überschreitet den Maximalwert.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Avviso conteggio righe: il conteggio righe (${i?.count}) è superiore al valore massimo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предупреждение о количестве строк: количество строк (${i?.count}) превышает максимальное значение.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Advertencia de conteo de líneas: el conteo de líneas (${i?.count}) es superior al valor máximo`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`行数警告：行数 (${i?.count}) 超过最大值`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`行数警告: 行数 (${i?.count}) が最大値を超えています`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`पंक्ति गणना चेतावनी: पंक्ति गणना (${i?.count}) अधिकतम मान से अधिक है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Aviso de contagem de linhas: a contagem de linhas (${i?.count}) está acima do valor máximo.`)
	return /** @type {LocalizedString} */ (`Line count warning: line count (${i?.count}) is above max value`)
});